import * as React from "react";
import { useEffect, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getEssayCorrections } from "../moderator.slice";
import { ICorrection } from "../../../app/interfaces";
import { getTheme } from "../../teacher/correction/correction.slice";
import Theme from "../../../app/components/theme.component";

import CorrectionTable from "../../../components/moderator/correction-table/correction-table.component";
import ExamHeader from "../../../components/moderator/exam-header/exam-header.component";

export default function ModerationEssayDetail(props: {
  onCorrectionSelected: (id: number) => void;
}) {
  const dispatch = useAppDispatch();
  const moderationState = useAppSelector((state) => state.moderation);
  const correctionState = useAppSelector((state) => state.correction);
  const [selectedCorrection, setSelectedCorrection] =
    useState<ICorrection | null>();
  const [showTheme, setShowTheme] = useState(false);
  const [image] = useState(new window.Image());

  useEffect(() => {
    setSelectedCorrection(undefined);
    dispatch(getEssayCorrections(moderationState.selectedEssay?.id || 0));
    if (moderationState.selectedEssay?.url) {
      image.src = moderationState.selectedEssay.url;
    }
    dispatch(getTheme(moderationState.selectedEssay?.themeId + ""));
  }, [moderationState.selectedEssay]);

  useEffect(() => {
    const correction = moderationState.selectedEssayCorrections[0];
    setSelectedCorrection(correction);
  }, [moderationState.selectedEssayCorrections]);

  useEffect(() => {
    if (moderationState.duplicateCorrection) {
      setSelectedCorrection(moderationState.duplicateCorrection);
    }
  }, [moderationState.duplicateCorrection]);

  useEffect(() => {
    if (selectedCorrection?.id) {
      props.onCorrectionSelected(selectedCorrection.id);
    }
  }, [selectedCorrection]);

  return (
    <Grid2 container>
      <Grid2 xs={12} sx={{ margin: "0px 15px" }}>
        <Theme
          open={showTheme}
          onClose={() => setShowTheme(false)}
          theme={correctionState.theme}
        />
        <ExamHeader
          theme={correctionState.theme.motivationalTitle}
          exam={correctionState.exam.name || ""}
          setSelectedCorrection={(status) => setSelectedCorrection(status)}
          showModal={(show) => setShowTheme(show)}
          origin="Moderation"
        />
        <CorrectionTable
          origin="moderation"
          data={moderationState.selectedEssayCorrections}
          selectedId={selectedCorrection?.id || 0}
          setSelected={(correction) => setSelectedCorrection(correction)}
        />
      </Grid2>
    </Grid2>
  );
}
